import styled from 'styled-components';
import AccountSettingsItem from './AccountSettingsItem';
import { colorSchema, media } from 'utils/style';

export default styled(AccountSettingsItem)`
  .account-settings-item {
    border-bottom: 1px solid ${colorSchema('grey200')};
    padding: 3.2rem 0;

    &__body {
      display: flex;
      flex-direction: column;

      ${media.greaterThan('tablet')`
        flex-direction: row;
      `}
    }

    &__side {
      width: 100%;
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: normal;
      margin: 0;
      margin-bottom: 0.8rem;
    }

    &__description {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
      margin-bottom: 0.8rem;

      ${media.greaterThan('tablet')`
        margin: 0;
      `}
    }
  }
`;
